import { URLS } from '@constants'
import {
  ApiRestrictionData,
  DELETEViewRestrictionParams,
  GETViewRestrictionsParams,
  POSTRestriction,
} from '@types'

import { commonAPI } from './common.api'

export const restrictionsAPI = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchRestrictionsByViewId: build.query<ApiRestrictionData, GETViewRestrictionsParams>({
      query: ({ viewId, restrictionType }) => ({
        url: URLS.FRONT_CFG + `/restriction/getByViewId/${viewId}`,
        params: {
          restrictionType,
        },
      }),
      providesTags: ['Restrictions'],
    }),
    fetchDefaultRestrictionsByView: build.query<ApiRestrictionData, GETViewRestrictionsParams>({
      query: ({ viewId }) => ({
        url: URLS.FRONT_CFG + `/restriction/default/getByViewId/${viewId}`,
        method: 'GET',
      }),
      providesTags: ['DefaultRestrictions'],
    }),
    updateRestrictions: build.mutation<POSTRestriction[], POSTRestriction[]>({
      query: restrictions => ({
        url: URLS.FRONT_CFG + '/restriction',
        method: 'POST',
        body: restrictions,
      }),
      invalidatesTags: ['Restrictions'],
    }),
    updateDefaultRestrictions: build.mutation<POSTRestriction[], POSTRestriction[]>({
      query: restrictions => ({
        url: URLS.FRONT_CFG + '/restriction/default',
        method: 'POST',
        body: restrictions,
      }),
      invalidatesTags: ['DefaultRestrictions'],
    }),
    deleteViewRestrictionsByType: build.mutation<null, DELETEViewRestrictionParams>({
      query: ({ viewId, restrictionType }) => ({
        url: URLS.FRONT_CFG + `/restriction/viewId/${viewId}`,
        method: 'DELETE',
        params: {
          type: restrictionType,
        },
      }),
      invalidatesTags: ['SingleView', 'Restrictions'],
    }),
    deleteViewDefaultRestrictionsByType: build.mutation<null, DELETEViewRestrictionParams>({
      query: ({ viewId, restrictionType }) => ({
        url: URLS.FRONT_CFG + `/restriction/default/viewId/${viewId}`,
        method: 'DELETE',
        params: {
          type: restrictionType,
        },
      }),
      invalidatesTags: ['SingleView', 'Restrictions', 'DefaultRestrictions'],
    }),
  }),
})

export const {
  useFetchRestrictionsByViewIdQuery,
  useLazyFetchDefaultRestrictionsByViewQuery,
  useUpdateDefaultRestrictionsMutation,
  useUpdateRestrictionsMutation,
  useDeleteViewRestrictionsByTypeMutation,
  useDeleteViewDefaultRestrictionsByTypeMutation,
  useLazyFetchRestrictionsByViewIdQuery,
} = restrictionsAPI
